import { useTranslation, useScrollAnimation, useStaggerAnimation } from '../hooks';

const Services = () => {
  const { t } = useTranslation();

  // Animation pour le titre et la description
  const { ref: titleRef, isVisible: isTitleVisible } = useScrollAnimation({
    threshold: 0.2,
    rootMargin: '0px 0px -100px 0px'
  });

  // Animation stagger pour les cartes de services
  const { containerRef, getItemStyle } = useStaggerAnimation(t.services.items.length, {
    staggerDelay: 150,
    threshold: 0.1
  });

  return (
    <section id="services" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Titre et description avec animation */}
        <div
          ref={titleRef}
          className="text-center mb-20"
          style={{
            opacity: isTitleVisible ? 1 : 0,
            transform: isTitleVisible ? 'translateY(0)' : 'translateY(40px)',
            transition: 'opacity 0.8s ease-out, transform 0.8s ease-out'
          }}
        >
          <h2 className="text-4xl lg:text-5xl font-light mb-6 tracking-wide">{t.services.title}</h2>
          <div className="max-w-4xl mx-auto space-y-4">
            <p
              className="text-xl text-gray-600 leading-relaxed"
              style={{
                opacity: isTitleVisible ? 1 : 0,
                transform: isTitleVisible ? 'translateY(0)' : 'translateY(20px)',
                transition: 'opacity 0.8s ease-out 0.2s, transform 0.8s ease-out 0.2s'
              }}
            >
              {t.services.intro}
            </p>
            <p
              className="text-lg text-gray-600 leading-relaxed"
              style={{
                opacity: isTitleVisible ? 1 : 0,
                transform: isTitleVisible ? 'translateY(0)' : 'translateY(20px)',
                transition: 'opacity 0.8s ease-out 0.3s, transform 0.8s ease-out 0.3s'
              }}
            >
              {t.services.description1}
            </p>
            <p
              className="text-lg text-gray-600 leading-relaxed"
              style={{
                opacity: isTitleVisible ? 1 : 0,
                transform: isTitleVisible ? 'translateY(0)' : 'translateY(20px)',
                transition: 'opacity 0.8s ease-out 0.4s, transform 0.8s ease-out 0.4s'
              }}
            >
              {t.services.description2}
            </p>
          </div>
        </div>

        {/* Grille de services avec animation stagger */}
        <div ref={containerRef} className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {t.services.items.map((service, index) => (
            <div
              key={index}
              style={getItemStyle(index)}
              className="bg-white p-8 shadow-lg hover:shadow-2xl transition-all duration-300 group border-t-4 border-black"
            >
              <div className="text-5xl mb-6 group-hover:scale-110 transition-transform">
                {service.icon}
              </div>
              <h3 className="text-xl font-semibold mb-4 tracking-wide">{service.title}</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">{service.description}</p>
              <ul className="space-y-2">
                {service.features.map((feature, fIndex) => (
                  <li key={fIndex} className="text-sm text-gray-500 flex items-center">
                    <div className="w-1 h-1 bg-black rounded-full mr-3"></div>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
